import React from "react";

import './TakeALiveTestBanner.scss';
import Config, { DeploymentType, IConfig, SourceApp } from "../../Config";
import WebUtils from "../../services/WebUtils";

const $document = $(document);

interface IProps {
    handleShowTestYourselfModal: () => void;
    deploymentType: DeploymentType;
    sourceApp: SourceApp;
}
interface IState {
    isHovered: false;
    lastTestDate: any;
}

class TakeALiveTestBanner extends React.Component<IProps, IState> {
    private webUtils: WebUtils;
    private config: IConfig;
    

	constructor(props: IProps) {
		super(props);
        this.config = Config.getConfig(this.props.sourceApp, this.props.deploymentType);
        this.webUtils = new WebUtils(this.config);
        this.fetchData();
	}

    private fetchData() {
        let url = this.webUtils.getAbsoluteBackendUrl("liveTest/getLastTestDate").replace("3001", "8080");

        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            this.setState({lastTestDate: data?.lastDate});
            console.log('data: ', data);
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation: ', error);
        });
    }
    
    public componentDidMount() {}
    
    public render() {
        let mainContent;
        mainContent = (
           <div className="livetest-button-start">
                 <div className="manning-online-livetest-top-icon">
                    <span className="manning-online-liveTest-icon">
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.16 45.1">
                    <defs>
                        <style>
                        
                        </style>
                    </defs>
                    <path className="cls-1" d="M42.09,25.08l-2.59-10.25c-1.08-4.35-3.48-7.95-7.12-10.7C28.75,1.39,24.62,0,20.11,0c-5.56,0-10.35,1.97-14.24,5.86S0,14.53,0,20.08c0,2.86.67,5.68,1.98,8.38,1.27,2.62,3.07,5.02,5.34,7.13v7.88c0,.45.16.85.46,1.15.3.31.71.48,1.16.48s.85-.16,1.16-.47c.31-.31.48-.71.48-1.16v-9.03c0-.17-.07-.32-.19-.44l-1.46-1.37c-1.79-1.66-3.2-3.6-4.19-5.74-.98-2.14-1.48-4.45-1.48-6.86,0-4.65,1.65-8.65,4.92-11.88,3.26-3.23,7.28-4.87,11.93-4.87,3.81,0,7.28,1.15,10.32,3.41,3.03,2.25,5.02,5.25,5.92,8.9l2.26,9.19h-4.16c-.67,0-1.24.23-1.7.69-.46.46-.69,1.03-.69,1.69v8.91c0,.28-.08.49-.25.66-.17.17-.38.25-.65.25h-6.47c-.67,0-1.23.23-1.69.68-.46.45-.69,1.03-.69,1.73v4.1c0,.45.16.85.46,1.15.3.31.71.48,1.16.48s.85-.16,1.16-.47c.31-.31.48-.71.48-1.16v-3.25h5.59c1.12,0,2.11-.42,2.93-1.23.82-.82,1.24-1.8,1.24-2.93v-8.03h4.43c.79,0,1.44-.31,1.9-.91.45-.59.6-1.29.42-2.03Z"/>
                    <path className="cls-1" d="M29.37,21.52c0-1.88-.6-3.5-1.78-4.84-1.2-1.35-2.72-2.04-4.52-2.04-1.5,0-2.82.49-3.92,1.46-1.12.99-1.68,2.22-1.68,3.66,0,.62.12,1.25.36,1.89.25.66.64,1.23,1.15,1.69.37.36.77.55,1.2.55.02,0,.13,0,.15,0,.43-.05.8-.22,1.09-.52.26-.28.43-.61.49-.98.06-.32.03-.8-.46-1.27-.18-.18-.36-.41-.52-.69-.14-.23-.2-.44-.2-.66,0-.42.19-.81.58-1.21.38-.39.96-.58,1.76-.58s1.51.31,2.12.96c.62.66.93,1.52.93,2.65,0,1.24-.48,2.3-1.48,3.22-1.01.94-2.29,1.39-3.91,1.39-1.82,0-3.35-.71-4.68-2.18-1.34-1.48-2-3.29-2-5.54,0-.94.16-1.86.48-2.75.32-.9.79-1.75,1.37-2.52.28-.33.43-.71.46-1.13.03-.44-.12-.87-.48-1.27-.33-.3-.72-.46-1.2-.46h0c-.48.01-.89.22-1.16.58-.88,1.02-1.57,2.19-2.06,3.47-.48,1.28-.73,2.63-.73,4.02,0,3.01.96,5.62,2.85,7.76,1.91,2.17,4.3,3.26,7.11,3.26,2.35,0,4.4-.77,6.1-2.28,1.72-1.53,2.59-3.43,2.59-5.65Z"/>
                    </svg>
                    </span>
                    <span className="manning-online-liveTest-caption">liveTest</span>
                 </div>
                 <div className="manning-online-livetest-text">
                    lock in what you have read! 
                 </div>
                 <div className="manning-online-livetest-buttons-container">
                    <button className="manning-online-livetest-choose-book-button" onClick={() => this.props.handleShowTestYourselfModal()}>start a test</button>
                 </div>
                 <div className="manning-online-livetest-last-test-callout">
                    <span>
                        {this.state?.lastTestDate ? `your last test — ${new Date(this.state.lastTestDate).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: '2-digit' })}` : 
                        <div>you haven't tried a test<br/>don't miss out, try today</div>} 
                    </span>
                </div>
           </div>
        )
		return (
			<React.Fragment>
				{mainContent}
			</React.Fragment>
		)
	}
}

export default TakeALiveTestBanner;
